
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 2880 1440"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0l.309.951L-.5.363h1l-.809.588z"}})]),_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h2880v1440H0z"}}),_c('path',{attrs:{"fill":"#002b7f","d":"M0 0h1440v720H0z"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(160 0 0 160 720 30)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(160 0 0 160 500 210)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(150 0 0 150 945 180)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(100 0 0 100 830 364.894)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"matrix(200 0 0 200 720 499.789)"}})])])
          )
        }
      }
    